import React, { FC, useState } from 'react';
import { Form } from 'react-bootstrap';

interface FormProps {
  children: React.ReactNode;
  onSubmitCallback: () => void;
}

const ValidationForm: FC<FormProps> = ({ children, onSubmitCallback }) => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setValidated(true);
    onSubmitCallback();
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      {children}
    </Form>
  );
};

export default ValidationForm;
